import { InformationOutlineIcon } from './InformationOutlineIcon';

/**
 * author: Google
 * id F7C01A96-16E0-44C0-A261-2CF22D056A7F
 * name information-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-outline.svg
 * tags
 * - Settings 
 */
export const InfoCircleOutlineIcon = InformationOutlineIcon;
export default InfoCircleOutlineIcon